module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// StaticAutocomplete Widget

(function (fox) {

	'use strict';

	fox.registerWidget('StaticAutocomplete', {

		configure: function (argument) {
			this.params = {};
			this.key = null;

			this.registerOptions('', {
				matchFiled: 'login',

				widgets: {
					api: {
						widget: 'Api',
						method: 'conversation.getMembers'
					}
				},

				handleWom: {
					handleApiStateChange: {
						widget: '#api',
						event: ['prepare', 'success', 'failure', 'loadError', 'loaded'],
						callback: '_handleApiStateChange'
					},
				}
			});

			this.callParent('configure', arguments);
		},

		running: function (argument) {
			var params = this.getOption('apiParams');

			this.api = this.wom1('#api');

			if (params) {
				this.setParams(params);
			}

			this.callParent('running', arguments);
		},

		setParams: function (params) {
			this.params = params;
			
			if (this.isDlWidget()) {
				this.api.setTransitParameter(params);
			}

			return this;
		},

		load: function () {
			
			if (this.isDlWidget()) {
				this.api.load();

				return;
			}
			this.params.transitParameters = {
				preset: 'premium-active' 
			}
			this.api.send(this.params);
		},

		_handleApiStateChange: function (response, api, e) {
			if (fox.inArray(['loading', 'prepare'], e)) {
				this.dispatchEvent('api_start', response);

				return;
			}

			if (fox.inArray(['failure', 'error', 'loadError'], e)) {
				this.dispatchEvent('api_failure', response);

				return;
			}

			this.hookWrapper('setApiResponse', response);
			this.dispatchEvent('api_success', this.getData());
		},

		setApiResponse: function (response) {
			var resp = [];

			if (this.isDlWidget()) {
				this.setData(this.api.getCollection());

				return;
			}

			this.setData(response.answer.response.success);

			return this;
		},

		setData: function (data) {
			this.responseData = data;

			return this;
		},

		getData: function (argument) {
			return this.responseData;
		},

		filterByKey: function (key) {
			key = key.toLocaleLowerCase();

			this.resetFilterResult();

			if (!key.length) {
				this.setKey(null);

				return;
			}
			
			this.setKey(key);
			this.hookWrapper('filter', {key: key});
			this.dispatchEvent('filtered', {result: this.filterResult});

			return this;
		},

		setKey: function (key) {
			this.key = key;			
		},

		getKey: function (argument) {
			return this.key;
		},

		filter: function (params) {
			fox.each(this.getData(), function (data, key) {
				data = fox.clone(data);

				if (!data[this.getOption('matchFiled')]) {
					console.warn(['api response in widget', this.getClass() + '#' + this.getAlias(), 'hasn\'t field', this.getOption('matchFiled')].join(' '));

					throw fox.break;
				}

				var field = data[this.getOption('matchFiled')].toLocaleLowerCase();

				if (field.match(params.key)) {
					data.filterKey = params.key;
					this.filterResult.push(data);
				}
			}, this);
		},

		resetFilterResult: function (argument) {
			this.filterResult = [];

			return this;			
		},

		getFilterResult: function (argument) {
			return this.filterResult;
		},

		isDlWidget: function() {
			return this.api._widgetClass === 'Datalayer';
		}

	}, 'Controller');

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/staticAutocomplete.js
// module id = 360
// module chunks = 2